<template>
  <div class="poper-box" v-if="visible">
    <div class="img-box">
      <div style="position: relative">
        <img
          v-if="number === 1"
          style="max-width: 100%; max-height: 80vh"
          src="@/baidupteAssets/image/popu2.png"
          alt=""
          @click="open"
        />
        <img
          v-else-if="number === 2"
          style="max-width: 100%; max-height: 80vh"
          src="@/baidupteAssets/image/baidu.png"
          alt=""
          @click="open"
        />
        <img
          v-else-if="number === 3"
          style="max-width: 100%; max-height: 80vh"
          src="@/baidupteAssets/image/web-3.png"
          alt=""
          @click="open"
        />
        <img
          v-else-if="number === 4"
          style="max-width: 100%; max-height: 80vh"
          src="@/baidupteAssets/image/web-4.png"
          alt=""
          @click="open"
        />
        <img
          :class="[`img-${props.number}`]"
          style="position: absolute; bottom: 24.5%; right: 10.4%; width: 15%"
          :src="configStore.baiduCode.value"
          alt=""
        />
      </div>
      <div class="close-but" @click="close" style="margin-bottom: auto">
        <el-icon :size="30" color="#ffffff">
          <CircleClose />
        </el-icon>
      </div>
    </div>
  </div>
  <!-- <el-dialog v-model="visible" align-center @close="close">
        <img :src="model?.imageUrl" alt="" @click="open">
    </el-dialog> -->
</template>

<script setup lang="ts">
import { onMounted, ref, onBeforeUnmount } from 'vue'
import type { PropType } from 'vue'
import { type AdvWindowPoperProps } from './index.type'
import { CircleClose } from '@element-plus/icons-vue'
import { useConfigStore } from '@/store/config.store'
import { storeToRefs } from 'pinia'
const configStore = storeToRefs(useConfigStore())

const props = defineProps({
  model: {
    type: Object as PropType<AdvWindowPoperProps>
  },
  number: {
    type: Number
  }
})

const emits = defineEmits(['closed'])

const visible = ref(props.model ? true : false)

const close = () => {
  visible.value = false
  emits('closed')
  console.log('close')
}

const open = () => {
  if (props.model?.url) {
    window.open(props.model.url, '_blank')
  }
  close()
}

const keydownListener = (event: any) => {
  if (event.key === 'Escape') {
    close()
  }
}

onMounted(() => {
  window.addEventListener('keydown', keydownListener)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', keydownListener)
})
</script>

<style scoped lang="scss">
.poper-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: #0000002e;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .img-box {
    display: inline-block;
    /* 确保图片和按钮包裹在一个盒子内，如果图片已经是块级元素，这步可能不需要 */

    position: relative;
    max-height: 100%;
    max-width: 100%;

    img {
      cursor: pointer;
    }
    .img-1 {
      bottom: 5.9% !important;
      right: 7.4% !important;
      width: 28% !important;
    }
    .img-3 {
      bottom: 10.9% !important;
      right: 7.3% !important;
      width: 16% !important;
    }
    .img-4 {
      bottom: 6% !important;
      right: 5% !important;
      width: 15% !important;
    }

    .close-but {
      position: absolute;
      top: 0;
      /* 距离顶部0，即在右上角 */
      right: -30px;
      cursor: pointer;
    }
  }
}
</style>
